import React, { FC } from 'react'

import Button from '@dashboard/components/Button'
import Container from '@dashboard/components/Container'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'

interface OwnProps {
  actionText?: string
  crystalBackground?: boolean
  img?: string
  lightSubtitle?: boolean
  noBottomPadding?: boolean
  padBottom?: boolean
  subtitle?: string
  time?: string
  title?: string
  to?: string
  vertical?: boolean
  white?: boolean
  blueSmall?: boolean
  children?: React.ReactNode
  action?: () => void
}

const classNames = classNamesBind.bind(css)

const CompanyIcon = '/static/share/images/company.svg'

const Header: FC<OwnProps> = ({
  noBottomPadding,
  padBottom,
  white,
  vertical,
  crystalBackground,
  children,
  img,
  title,
  blueSmall,
  action,
  actionText,
  to,
  time,
  subtitle,
  lightSubtitle,
}: OwnProps) => {
  // Functions
  const handleImageError = (
    evt: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    const target = evt.target as HTMLImageElement
    target.src = CompanyIcon
  }

  // Partials
  const renderImage = () => {
    if (!img) return null

    return (
      <img onError={handleImageError} src={img} className={classNames('img')} />
    )
  }

  const renderTitle = () => {
    if (!title) return null

    return (
      <h2 className={classNames('title', { blueSmall })}>
        {title}
        {renderTime()}
      </h2>
    )
  }

  const renderSubtitle = () => {
    if (!subtitle) return null

    return (
      <p
        className={classNames('subtitle', { lightSubtitle })}
        dangerouslySetInnerHTML={{ __html: subtitle }}
      />
    )
  }

  const renderAction = () => {
    if ((action || to) && actionText) {
      return (
        <div className={classNames('button')}>
          <Button onClick={action} to={to} small>
            {actionText}
          </Button>
        </div>
      )
    }
    return null
  }

  const renderTime = () => {
    if (!time) return null

    return <span className={classNames('time')}>{time}</span>
  }

  return (
    <header
      className={classNames('wrapper', {
        noBottomPadding,
        crystalBackground,
        padBottom,
        vertical,
        white,
      })}
    >
      <Container>
        <div className={classNames('top')}>
          {renderImage()}
          <div className={classNames('titles')}>
            {renderTitle()}
            {renderSubtitle()}
          </div>
          {renderAction()}
        </div>
        {children}
      </Container>
    </header>
  )
}

export default Header
